// utils/transformProduct.js
export const toSpecArray = (sizes = []) =>
  sizes
    .map(({ key, weight }) => ({
      specificationName: String(key),
      weight: weight ? Number(weight) : "",
    }));

export const transformProduct = (data) => {
  return {
    ...data,
    blankSampleSpecifications: toSpecArray(data?.blankSampleSpecifications?.sizes),
    samplingSpecifications: toSpecArray(data?.samplingSpecifications?.sizes),
    bulkSpecifications: toSpecArray(data?.bulkSpecifications?.sizes),
    isLogoColor: data.isLogoColor,
    logoColor: data.logoColor,
    logoOpacity: data.logoOpacity,
  };
};
